<template>
  <footer class="site-footer" role="contentinfo">
    <div class="wrap">
      <p class="disclaimer">
        Budgetary estimates only - always validate with your robot vendor or integrator.
        Not a substitute for risk assessment or safety review.
        We are independent and not affiliated with, endorsed by, or representing any robot manufacturer;
        model names are used for identification only.
      </p>

      <nav class="legal">
        <router-link to="/disclaimer">Disclaimer</router-link>
        <span aria-hidden="true">•</span>
        <router-link to="/terms">Terms</router-link>
        <span aria-hidden="true">•</span>
        <router-link to="/privacy">Privacy</router-link>
      </nav>
    </div>
  </footer>
</template>

<script setup>
/* no props/state needed */
</script>

<style scoped>
.site-footer{
  background:#fff;
  border-top:1px solid #e5e7eb;
}
.wrap{
  max-width:72rem; margin:0 auto; padding:14px 16px;
  display:flex; flex-direction:column; align-items:center; gap:8px;
  text-align:center;
}
.disclaimer{
  margin:0;
  color:#475569;            /* slate-600 */
  font-size:.95rem;
  line-height:1.45;
  max-width:900px;
}
.legal{
  display:flex; align-items:center; gap:.5rem;
  color:#111827;
  font-weight:700;
}
.legal a{
  color:#111827; text-decoration:none;
}
.legal a:hover{
  text-decoration:underline;
}
</style>
